import { API } from 'aws-amplify';

export const currentLang = () => {
	if ("lang" in currentLangParam() && document?.documentElement?.lang === undefined) {
		document.documentElement.lang = currentLangParam().lang;
	}
	
	// return currentLang en/fr
	return document?.documentElement?.lang ?? 'en';
}

export const currentLangParam = () => {
	//grabbing the urlParameters if they are currently stored
	const urlParameters = localStorage.getItem("urlParameters");
	const paramDict = {};
	if (urlParameters !== null) {
		const paramList = urlParameters.split('&');
		for (const param of paramList) {
			const splitParam = param.split('=');
			paramDict[splitParam[0]] = splitParam[1]?.replaceAll("+", "%20");
		}
	}
	let languageChange = false;
	let langParam = {};
	let urlParams = new URLSearchParams(document.location.search);
	if (urlParams.has('lang')) {
		langParam = {lang: urlParams.get('lang')};

		//updating localstorage with new lang, if it's different
		if (urlParams.get('lang') !== paramDict.lang) {
			paramDict.lang = urlParams.get('lang');
			languageChange = true;
		}
	} else if (!!paramDict.lang) {
		urlParams.set("lang", paramDict.lang);
		langParam = {lang: paramDict.lang};
		if (document.documentElement?.lang !== paramDict.lang.substring(0,2)) {
			document.documentElement.lang = paramDict.lang.substring(0,2);	//updating language for WET
		}
		// eslint-disable-next-line no-restricted-globals
		history.replaceState(null, null, "?" + urlParams.toString());	//adding the language to the querystring so that if the user bookmarks the page, it'll load in the right language
	}

	//updating local storage with current language, if it's been changed or set -- just in case there's a bounce around that loses the URLSearchParams in the process
	if (languageChange) {
		let newUrlParams = Object.keys(paramDict).map(function(k) {
			return encodeURIComponent(k) + "=" + encodeURIComponent(paramDict[k]);
		}).join('&')
		localStorage.setItem("urlParameters", newUrlParams);
	}

	return langParam;
}

export const currentLongLang = () => {
	return currentLang() === "fr" ? "fra" : "eng";
}

//Label comes in via API as a split eng|fr string (e.g. 'hello|bonjour'), else return ''
export const getProgramTypeLabel = (engFrLabel) => {
	return engFrLabel?.split('|')[currentLang() === 'en' ? 0 : 1] ?? '';
}

export const getHealthCheck = async (appContext, errorMessage, willRedirect) => {
		
	let apiURL = "getHealthCheck";

	return API.get("backend-api", apiURL, {}).then(function(response){
		//successful health check, no need to do anything!
	}).catch((error) => {
		if (error === "No current user" || error === "The user is not authenticated") {
			return "Login";
		}
		let duration = !!willRedirect ? -2 : -1;
		appContext.setFlashError({duration: duration, messages:[errorMessage]});
		if (!!localStorage.getItem("activeKey")) {
			let activeKey = localStorage.getItem("activeKey");
			if (activeKey === "Account" || activeKey === "Account_Edit") {
				return activeKey;
			}
		}
		return "Login";
	});
}

export const bytesToNearestUnitStr = (sizeInBytes, messages, decimalPlaces) => {
	let resultSize = sizeInBytes;
	let unit = messages["common.bytes"];
	if (resultSize > 1000) {
		resultSize /= 1000;
		unit = messages["common.kilobytes"];
	}
	if (resultSize > 1000) {
		resultSize /= 1000;
		unit = messages["common.megabytes"];
	}
	if (resultSize > 1000) {
		resultSize /= 1000;
		unit = messages["common.gigabytes"];
	}
	if (resultSize > 1000) {
		resultSize /= 1000;
		unit = messages["common.terabytes"];
	}
	if (unit !== messages["common.bytes"]) {
		if (!!decimalPlaces && parseInt(decimalPlaces)) {
			resultSize = resultSize.toFixed(decimalPlaces);
		} else {
			resultSize = resultSize.toFixed(1);
		}
	}
	return resultSize + " " + unit;
}